import Grid from "@material-ui/core/Grid";
import I18n from "./locale/I18n.js";
import Link from "./Link.js";
import { makeStyles } from "@material-ui/core/styles";
import PageTile from "../layout/PageTile.js";
import React from "react";

const useStyles = makeStyles(theme => ({
    root: {
        color: "#eee"
    },
    link: {
        color: "#eee",
        textDecoration: "none"
    }
}));

const Footer = () => {
    const classes = useStyles();
    return (
        <PageTile backgroundColor="#333" verticalPadding={6}>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <div>Lateral Studio Sàrl</div>
                        <div>Chemin de Bérée 22B</div>
                        <div>CH-1010 Lausanne</div>
                        <br />
                        <div>
                            <a
                                href="mailto:contact@lateralstudio.ch"
                                className={classes.link}
                            >
                                contact@lateralstudio.ch
                            </a>
                        </div>
                        <div>+41 (0) 76 516 86 71</div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <br />
                        <div>
                            <Link
                                target="/PrivacyPolicy"
                                className={classes.link}
                            >
                                <I18n label="PrivacyPolicy" />
                            </Link>
                        </div>
                        <div>
                            <Link target="/Impressum" className={classes.link}>
                                <I18n label="Impressum" />
                            </Link>
                        </div>
                        <br />
                        <div>
                            ©{new Date().getFullYear()} Lateral Studio Sàrl
                        </div>
                    </Grid>
                </Grid>
            </div>
        </PageTile>
    );
};

export default Footer;
